import { useEffect, useState } from "react";
import { Overlay } from "react-bootstrap";
import { ReactComponent as OutlineCheckSmall } from "assets/svg/outline-check-small.svg";

const SuccessTag = ({
  show,
  onHide,
  duration,
  successMsg,
  target,
  placement,
}) => {
  const [localShow, setLocalShow] = useState(show);

  useEffect(() => setLocalShow(show), [show]);

  useEffect(() => {
    if (!localShow) {
      return;
    }
    const timer = setTimeout(() => {
      setLocalShow(false);
      onHide && onHide();
    }, duration ?? 2000);

    return () => timer && clearTimeout(timer);
  }, [localShow, onHide, duration]);

  return localShow && target ? (
    <Overlay target={target} show={show} placement={placement} flip={true}>
      {({
        placement: _placement,
        arrowProps: _arrowProps,
        show: _show,
        popper: _popper,
        hasDoneInitialMeasure: _hasDoneInitialMeasure,
        ...props
      }) => (
        <div
          {...props}
          style={{
            position: "absolute",
            display: "flex",
            alignItems: "center",
            // backgroundColor: "rgba(0, 0, 0, 0.45)",
            backgroundColor: "#333",
            padding: "4px 8px",
            fontSize: "12px",
            // marginBottom: "12px",
            // marginLeft: "12px",
            color: "white",
            borderRadius: 4,
            zIndex: 100000000,
            gap: 4,
            ...props.style,
          }}
        >
          <OutlineCheckSmall />
          {successMsg}
        </div>
      )}
    </Overlay>
  ) : null;
};

export default SuccessTag;
